import axios from '@/libs/http'
import {appendIfNotEmpty} from "@/libs/util";

/**
 * 查询服务价格
 */
export const listItemPrice = ()=>{
    return axios.request({
        url: '/s/c/item/listPrice',
        method: 'get'
    })
}
/**
 * 更新服务自定义价格
 * @param itemId        服务id
 * @param clerkPrice    自定义价格
 */
export const updateClerkPrice = (itemId,clerkPrice)=>{
    let data = new URLSearchParams()
    data.append('itemId',itemId)
    appendIfNotEmpty(data,'clerkPrice',clerkPrice)
    return axios.request({
        url: '/s/c/item/updatePrice',
        data,
        method: 'post'
    })
}
